export default __webpack_public_path__ + "static/media/Bower-Bold.b287fdc3.otf";